import { useTranslation } from 'react-i18next';
import { Link } from '@tanstack/react-router';
import { Boton, Insignia } from '../componentes/ui/basicos';
import { Vacio } from '../componentes/ui/estados';
import { useSesion } from '../sesion/ProveedorDeSesion';

/**
 * Elegir en qué comercio pararse.
 *
 * También cubre el caso de quien tiene sesión y ninguna empresa —acaba de aceptar una
 * invitación para fundar la suya— que no es un error sino un paso del circuito.
 */
export function ElegirEmpresa(): React.ReactElement {
  const { t } = useTranslation();
  const { perfil, pararseEn, salir } = useSesion();
  const empresas = (perfil?.empresas ?? []).filter((empresa) => empresa.activa);

  return (
    <div className="grid min-h-dvh place-items-center px-4">
      <div className="w-full max-w-md rounded-marco border border-borde bg-superficie p-6">
        <h1 className="mb-1 text-lg font-semibold tracking-tight">
          {empresas.length === 0 ? t('empresa.sinEmpresas') : t('empresa.elegir')}
        </h1>
        <p className="mb-5 text-xs text-texto-tenue">{perfil?.correo ?? ''}</p>

        {empresas.length === 0 ? (
          <Vacio descripcion={t('empresa.ayudaSinEmpresas')} />
        ) : (
          <div className="flex flex-col gap-2">
            {empresas.map((empresa) => (
              <Boton
                key={empresa.empresaId}
                disabled={empresa.suspendida}
                onClick={() => void pararseEn(empresa.empresaId)}
                className="w-full justify-start gap-2"
              >
                {empresa.nombre}
                {/* Se muestra y no se esconde: que desaparezca de la lista se lee como «me
                    sacaron», y lo que pasó es otra cosa. */}
                {empresa.suspendida ? (
                  <Insignia tono="neutro">{t('empresa.suspendida')}</Insignia>
                ) : null}
              </Boton>
            ))}
          </div>
        )}

        {perfil?.esAdministradorDePlataforma === true ? (
          <Link to="/plataforma" className="mt-4 block">
            <Boton tono="secundario" className="w-full">
              {t('empresa.administrarPlataforma')}
            </Boton>
          </Link>
        ) : null}

        <Boton tono="sutil" className="mt-4 w-full" onClick={() => void salir()}>
          {t('acciones.salir')}
        </Boton>
      </div>
    </div>
  );
}
